module.exports = __webpack_public_path__ + "img/words12.b2f2bd8f.png";